import useAppSelector from '@/hooks/useAppSelector'
import { selectCurrentGroup } from '@/redux/slices/session'

export function useCurrentGroup() {
  return useAppSelector(selectCurrentGroup)
}
